import { render, staticRenderFns } from "./ArticleUnitPicker.vue?vue&type=template&id=2038dc50&scoped=true&"
import script from "./ArticleUnitPicker.vue?vue&type=script&lang=js&"
export * from "./ArticleUnitPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2038dc50",
  null
  
)

export default component.exports